import * as React from 'react';
import type { SVGProps } from 'react';
const SvgPaywall3Envelope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g fill="currentColor">
      <path d="M1.413 4.14a3 3 0 0 0-.06.397c-.02.25-.02.553-.02.904v5.118c0 .351 0 .655.02.904.022.264.07.526.198.778a2 2 0 0 0 .874.874c.253.129.515.177.778.198.25.02.553.02.905.02h7.784c.352 0 .655 0 .905-.02.263-.021.525-.07.778-.198a2 2 0 0 0 .874-.874c.128-.252.176-.514.197-.778.02-.25.02-.552.02-.904V5.441c0-.351 0-.655-.02-.904a3 3 0 0 0-.06-.398l-5.32 4.353a2 2 0 0 1-2.533 0z" />
      <path d="M13.827 3.038a2 2 0 0 0-.252-.153 2 2 0 0 0-.778-.198c-.25-.02-.553-.02-.905-.02H4.108c-.352 0-.655 0-.905.02-.263.022-.525.07-.778.198a2 2 0 0 0-.252.153L7.578 7.46c.245.2.599.2.844 0z" />
    </g>
  </svg>
);
export default SvgPaywall3Envelope;
